import React from "react";

import { formatPrintMoney } from "../financePrintUtils";

/**
 * Print-friendly finance summary: labeled horizontal bars (no canvas).
 * Doughnut charts are unreadable when printed; these ink cleanly.
 */
const PrintFinanceBars = ({ rows = [], percentLabel, percent }) => {
  const nums = rows.map((r) => Math.abs(Number(r.value) || 0));
  const max = Math.max(...nums, 1);
  const pct =
    percent == null || Number.isNaN(Number(percent))
      ? null
      : Math.max(0, Math.min(100, Math.round(Number(percent))));

  return (
    <div className="print-finance-bars">
      <div className="print-finance-bars-list">
        {rows.map((row) => {
          const abs = Math.abs(Number(row.value) || 0);
          const widthPct = Math.max(2, Math.round((abs / max) * 100));
          return (
            <div className="print-finance-bar-row" key={row.label}>
              <div className="print-finance-bar-meta">
                <span className="print-finance-bar-label">
                  <i style={{ background: row.color }} aria-hidden="true" />
                  {row.label}
                </span>
                <span className="print-finance-bar-value print-ltr-amount">
                  {formatPrintMoney(row.value)}
                </span>
              </div>
              <div className="print-finance-bar-track">
                <div
                  className="print-finance-bar-fill"
                  style={{
                    width: `${widthPct}%`,
                    background: row.color,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
      {pct != null && percentLabel ? (
        <div className="print-finance-bars-percent">
          <span>{percentLabel}</span>
          <strong className="print-ltr-amount">{pct}%</strong>
        </div>
      ) : null}
    </div>
  );
};

export default PrintFinanceBars;
